/**
 * Admin Dashboard Component - Container for admin management interfaces
 */
import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import { People, Mail } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ModernHeader from '@/components/common/ModernHeader';
import UserManagement from './UserManagement';
import InvitationManagement from './InvitationManagement';

const AdminDashboard: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <ModernHeader />
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <Paper sx={{ m: 2, mb: 0 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              icon={<People />}
              iconPosition="start"
              label={t('admin.dashboard.users', 'Users')}
            />
            <Tab
              icon={<Mail />}
              iconPosition="start"
              label={t('admin.dashboard.invitations', 'Invitations')}
            />
          </Tabs>
        </Paper>

        <Box sx={{ p: 3 }}>
          {activeTab === 0 && <UserManagement />}
          {activeTab === 1 && <InvitationManagement />}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminDashboard;
